import UserChallengeAnswers from './UserChallengeAnswers';

export default UserChallengeAnswers;
